import { USER_STATE_LOCAL_STORAGE_KEY, USER_REDUCER_NAME, LOGIN_MODAL_TYPE } from './Constants';

import { useIsLoggedIn, useSub, useUser } from './Selector';
import userReducer, { setLoggedIn, setUserInfo, removeAllUserState } from './Reducer';
import { saveUserInLocalStorage } from './Middleware';
import { removeUserInLocalStorage } from './UserController';

export {
  USER_STATE_LOCAL_STORAGE_KEY,
  USER_REDUCER_NAME,
  LOGIN_MODAL_TYPE,
  useIsLoggedIn,
  useSub,
  useUser,
  setLoggedIn,
  setUserInfo,
  removeAllUserState,
  saveUserInLocalStorage,
  removeUserInLocalStorage,
};

export default userReducer;
